import * as React from "react";
import { Modal, Checkbox, Button } from "antd";
import { LocalStorageMock } from "./../../../common/utils";

interface Props {
  visible: boolean;
  onClose(): void;
}

interface State {
  doNotShowModalAgain: boolean;
}

let localStorage = window.localStorage ? window.localStorage : LocalStorageMock;

export default class UpdateInfoModal extends React.Component<Props, State> {
  state = {
    doNotShowModalAgain: false
  };

  toggleCheckbox = () => {
    this.setState(prevState => ({ doNotShowModalAgain: !prevState.doNotShowModalAgain }));
  };

  handleClose = () => {
    this.state.doNotShowModalAgain &&
      localStorage.setItem("agreedToUpdateInfo", "true");
    this.props.onClose();
  };

  render() {
    return (
      <Modal
        title="Updates coming to the Retailer Reporting dashboard on March 29, 2021:"
        visible={
          localStorage.getItem("agreedToTOS") &&
          localStorage.getItem("agreedToHosted2") &&
          !localStorage.getItem("agreedToUpdateInfo") &&
          this.props.visible
        }
        wrapClassName="tos-modal"
        maskClosable={true}
        footer={[
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginLeft: "6px"
            }}
          >
            <Checkbox
              checked={this.state.doNotShowModalAgain}
              onChange={this.toggleCheckbox}
            >
              Do now show me the message again
            </Checkbox>
            <Button className="ant-btn-secondary" onClick={this.handleClose}>
              OK
            </Button>
          </div>
        ]}
      >
        <div
          style={{
            borderRadius: 1,
            border: "1px solid #e9e9e9",
            padding: "10px 15px"
          }}
        >
          <span style={{ fontWeight: "bold" }}>
            Content Heatmap will be Vertically Scrolling:
          </span>{" "}
          To provide an updated understanding of how consumers engage with your
          digital content, the Content Heatmap visualization will change to
          reflect the vertical publication experience.
          <br /> <br />{" "}
          <span style={{ fontWeight: "bold" }}>
            Metric Availability for all Hosted Versions:
          </span>{" "}
          Hosted metrics will now be available for all versions of our Hosted
          integrations.
          <br /> <br />
          <span style={{ fontWeight: "bold" }}>
            Deprecating the <i>Page Views</i> metric:
          </span>{" "}
          As vertical scrolling digital publications now provide a seamless
          exploration experience, there is no longer the concept of a ‘page’. As
          such, we will be deprecating the page-view metric.
          <br /> <br />
          <span style={{ fontWeight: "bold" }}>
            <i>User Engaged Clicks</i> definition change:
          </span>{" "}
          We have refined our metrics definition to better help you understand
          what content your users are engaging with. Hence there will be a 1
          time change in benchmark that may appear to lower the overall ‘Flyer
          Click’ metric.
          <br /> <br />
          <span style={{ fontWeight: "bold" }}>
            <i>Item Views</i> as Aggregate:{" "}
          </span>
          Item views metric is changed from Avg per Session to overall
          aggregate.
          <br /> <br />
          <span style={{ fontWeight: "bold" }}>
            Total <i>Clicks</i> and <i>TTMs</i> metric for Flipp App to include
            eCom Module Item TTMs:{" "}
          </span>
          The total ‘Clicks’ and ‘TTMs’ metric for Flipp App will now be
          inclusive of flyer item TTMs + In-Flyer eCom module item TTMs.
          <br /> <br />
          <span style={{ fontWeight: "bold" }}>
            Data updated for the past 16 months:{" "}
          </span>
          To keep the year over year comparable, the changes outlined above will
          be applied to all data from the past 16 months.
          <br /> <br />
          <span style={{ fontWeight: "bold" }}>
            If you have any questions or concerns, please reach out to your
            account representative.
          </span>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/core/Modal/UpdatesInfoModal/index.tsx